import flow from 'lodash/flow';
import React from 'react';
import SVGIcon from 'components/SVGIcons';
import { DragSource, DropTarget } from 'react-dnd';
import draggableStyles from 'styles/partials/_draggableStyles.css';
import { BlurTextField } from '../connectedForm/inputComponents';

export const DraggableMenu = (props) => {
  if (props.homeIcon) {
    return props.dropTarget(
      <li key="fav-home" className={draggableStyles['homeIcon']} onClick={props.changeMenu.bind(null, null)}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
          }}
          tabIndex={props.tabIndex}
        >
          <div className={draggableStyles['navmenu-icon']}>
            <i className="navMenuIcon">keyboard_backspace</i>
          </div>
          <div className={draggableStyles['navmenu-title']}>{props.menu}</div>
        </a>
      </li>
    );
  }
  let menuName = props.menu.name ? props.menu.name : '';
  let folderName = (
    <div className="navmenu-title" id={'menu_' + menuName.replace(/ /g, '', '')}>
      {menuName}
    </div>
  );
  let clickEvent = props.changeMenu.bind(null, props.menu.id, true);
  let deleteFolder = null;
  if (props.editNames) {
    folderName = (
      <BlurTextField
        dataid="folder.name"
        onChange={(value) => props.onFolderChange(props.menu.id, value)}
        value={props.menu.name}
        onBlur={props.onBlur.bind(null, props.menu.concurrencyVersion, props.menu.id, props.menu.name)}
        id={`${props.menu.id}`}
        includeLabel={false}
        enableOnChange
      />
    );
    clickEvent = null;
    deleteFolder = (
      <span
        className={draggableStyles['delete']}
        onClick={props.deleteFolder.bind(null, props.menu.id, props.menu.concurrencyVersion, props.menu.sortOrder)}
      >
        X
      </span>
    );
  }

  if (!props.option.folder) {
    let key = 'menu_' + props.menu.title.replace(/ /g, '');
    return props.dropTarget(
      props.dragSource(
        <li key={key} onClick={props.changeMenu.bind(null, props.menu.url, 'screen')}>
          <a
            href={props.menu.url}
            onClick={(e) => {
              e.preventDefault();
            }}
            tabIndex={props.tabIndex}
          >
            <div className="navmenu-icon">
              <SVGIcon icon={props.menu.icon} fillColor="#607D8B" height={30} width={30} />
            </div>
            <div className="navmenu-title" id={key} title={props.menu.title}>
              {props.menu.title}
            </div>
          </a>
        </li>
      )
    );
  } else {
    let key = 'menufolder_' + props.menu.id;
    return props.dropTarget(
      props.dragSource(
        <li key={key} onClick={clickEvent}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
            }}
            tabIndex={props.tabIndex}
          >
            <div className="navmenu-icon">
              <i className="iconLarge">folder</i>
            </div>
            {folderName} {deleteFolder}
          </a>
        </li>
      )
    );
  }
};

const NAV_MENU = 'NavMenu';
const optionSource = {
  beginDrag(props) {
    return { fieldName: props.option.fieldName };
  },
  endDrag(props, monitor) {
    if (!monitor.didDrop()) {
      return;
    }

    let dropOn = monitor.getDropResult();
    dropOn.moveColumn(props.option.fieldName, dropOn.targetIndex, props.option.folder);
  },
  canDrag() {
    return true;
  },
};
const optionTarget = {
  drop(props) {
    return {
      moveColumn: props.option.moveColumn,
      targetIndex: props.index,
    };
  },
};
function collectTarget(connect, monitor) {
  return {
    dropTarget: connect.dropTarget(),
    canDrop: monitor.canDrop(),
    isDragOver: monitor.isOver(),
  };
}

function collectSource(connect, monitor) {
  return {
    dragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

export default flow(
  DragSource(NAV_MENU, optionSource, collectSource),
  DropTarget(NAV_MENU, optionTarget, collectTarget)
)(DraggableMenu);
